<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px" class="demo-ruleForm">
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="ruleForm.title" style="width:400px" />
      </el-form-item>
      <el-form-item label="活动名称" prop="descption">
        <el-input v-model="ruleForm.descption" v-model.trim="ruleForm.descption" style="width:400px" @input="ruleForm.descption = ruleForm.descption.replace(reg, '')" />
      </el-form-item>
      <el-form-item label="活动类型" prop="rechage_type">
        <el-select v-model="ruleForm.rechage_type" placeholder="请选择活动类型" @change="activechange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.rechage_type!=3" label="活动金额" prop="activity_money">
        <el-input v-model="ruleForm.activity_money" type="number" style="width:400px" placeholder="单位（元）" @blur="activemoney" />
      </el-form-item>
      <el-form-item v-if="ruleForm.rechage_type!=2" label="赠送金币（红包）" prop="give_money">
        <el-input v-model="ruleForm.give_money" type="number" style="width:400px" placeholder="单位（金币）" @blur="activegivemoney" />
      </el-form-item>

      <el-form-item v-if="ruleForm.rechage_type!=3" label="限购次数" prop="pay_limit">
        <el-select v-model="ruleForm.pay_limit" placeholder="请选择限购次数">
          <el-option
            v-for="item in restrictions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
        <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="活动时间" prop="timearr">
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>

      <el-form-item label="选择模板">
        <el-tag v-if="ruleForm.temp_id !== null" size="medium" style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;">{{ temp_id_name }}</el-tag>
        <el-button type="primary" @click="choosetheme">选择活动主题 </el-button>
      </el-form-item>

      <el-form-item label="弹窗状态">
        <el-radio-group v-model="ruleForm.is_popup" @change="popupser">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="ruleForm.is_popup == 1" label="弹窗位置" prop="checkList">
        <el-checkbox-group v-model="ruleForm.checkList">
          <el-checkbox-group v-model="ruleForm.checkList">
            <el-checkbox v-for="date in dates" :key="date.key" :label="date.key">{{ date.label }}</el-checkbox>
          </el-checkbox-group>
        </el-checkbox-group>
      </el-form-item>
      <!-- <el-form-item label="生效站点">
        <el-radio-group v-model="ruleForm.site">
          <el-radio :label="1">全部站点</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-top:10px" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="58%"
    >
      <themedialog ref="themeview" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import { acawraccountlist, readingservice } from '@/api/sourceMaterial.js'
import themedialog from './themedialog.vue'
export default {
  components: {
    themedialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        title: '',
        descption: '',
        rechage_type: 1,
        activity_money: '',
        give_money: '',
        pay_limit: '',
        timearr: [],
        temp_id: null,
        is_popup: 0,
        checkList: [],
        site: 1,
        appoint_day: ''
      },
      activeytype: null,
      dates: [
        {
          key: 2,
          label: '阅读历史'
        }, {
          key: 3,
          label: '充值'
        },
        {
          key: 4,
          label: '个人中心'
        },
        {
          key: 5,
          label: '分类'
        },
        {
          key: 6,
          label: '精选'
        },
        {
          key: 7,
          label: '排行'
        },
        {
          key: 8,
          label: '充值返回'
        }
      ],
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      starttime: '', // 开始时间
      endtime: '', // 结束时间
      temp_id_name: '', // 模板名称
      theme: [],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      restrictions: [{
        value: 0,
        label: '不限'
      }, {
        value: 1,
        label: '1次'
      }, {
        value: 2,
        label: '2次'
      },
      {
        value: 3,
        label: '3次'
      },
      {
        value: 4,
        label: '4次'
      },
      {
        value: 5,
        label: '5次'
      },
      {
        value: 10,
        label: '10次'
      }],
      dialogVisible: false,
      options: [{
        value: 1,
        label: '充值金额'
      }, {
        value: 2,
        label: '年费会员'
      }, {
        value: 3,
        label: '免费赠币'
      }],
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        descption: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        rechage_type: [
          { required: true, message: '请选择活动类型', trigger: 'change' }
        ],
        activity_money: [
          { required: true, message: '请输入活动金额', trigger: 'blur' }
        ],
        give_money: [
          { required: true, message: '请输入赠送金币', trigger: 'blur' }
        ],
        pay_limit: [
          { required: true, message: '请选择限购次数', trigger: 'change' }
        ],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        checkList: [
          { type: 'array', required: true, message: '请至少选择一个位置', trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getlistr()
  },
  mounted() {

  },
  methods: {
    async getlistr() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.rechage_type == 3) {
        const data = await acawraccountlist({
          platformId: this.platformid,
          activityType: 4
        })
        console.log(data.data.theme)
        this.theme = data.data.theme
        this.ruleForm.temp_id = data.data.theme[0].value
        this.temp_id_name = data.data.theme[0].description
        console.log('data', data)
      } else {
        const data = await acawraccountlist({
          platformId: this.platformid,
          activityType: this.ruleForm.rechage_type
        })
        console.log(data.data.theme)
        this.theme = data.data.theme
        this.ruleForm.temp_id = data.data.theme[0].value
        this.temp_id_name = data.data.theme[0].description
        console.log('data', data)
      }
    },
    activechange(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        console.log('第二个')
        this.ruleForm.give_money = ''
      }
      // eslint-disable-next-line eqeqeq
      if (val == 3) {
        console.log('第三个')
        this.ruleForm.pay_limit = 1
        this.ruleForm.activity_money = ''
      }
      this.getlistr()
    },
    choosetheme() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(this.theme, 1)
      })
    },
    close(item) {
      this.dialogVisible = false
      this.ruleForm.temp_id = item.value
      this.temp_id_name = item.description
      console.log('item', item)
    },
    activemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.activity_money <= 0 && this.ruleForm.activity_money != '') {
        this.ruleForm.activity_money = 1
      }
    },
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.give_money <= 0 && this.ruleForm.give_money != '') {
        this.ruleForm.give_money = 1
      }
    },
    datavalue(val) {
      console.log('val', val)
      this.starttime = val[0]
      this.endtime = val[1]
    },
    popupser(val) {
      console.log(val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.ruleForm.checkList = []
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.starttime
            par.end_time = this.endtime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          console.log('2222', this.ruleForm.rechage_type)
          // eslint-disable-next-line eqeqeq
          if (this.ruleForm.rechage_type == 1) {
            this.activeytype = this.ruleForm.rechage_type
          // eslint-disable-next-line eqeqeq
          } else if (this.ruleForm.rechage_type == 2) {
            this.activeytype = this.ruleForm.rechage_type
          } else {
            this.activeytype = 4
          }
          console.log('this.activeytype', this.activeytype, this.ruleForm.checkList.toString())
          readingservice({
            platform_id: this.platformid,
            activity_type: this.activeytype,
            ...par,
            activity_info: {
              title: this.ruleForm.title,
              descption: this.ruleForm.descption,
              activity_money: this.ruleForm.activity_money,
              rechage_type: this.ruleForm.rechage_type,
              give_money: this.ruleForm.give_money,
              pay_limit: this.ruleForm.pay_limit,
              popup_position: this.ruleForm.checkList.toString(),
              is_popup: this.ruleForm.is_popup,
              // starttime: this.starttime,
              // endtime: this.endtime,
              temp_id: this.ruleForm.temp_id,
              type: 0,
              register_type: 0,
              register_min: '',
              register_max: '',
              user_type: 0,
              paynum_type: 0,
              paynum_min: '',
              paynum_max: '',
              paymoney_type: 0,
              paymoney_min: '',
              paymoney_max: '',
              last_pay_type: 0,
              last_pay_min: '',
              last_pay_max: '',
              status: 2
            }
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/**
 * 解决el-input设置类型为number时，中文输入法光标上移问题
 **/
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}

/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
